<script>
  // import { beforeUpdate, afterUpdate } from "svelte";
  import ProductCard from "./components/ProductCard.svelte";
  import ProductsRenderer from "./components/ProductsRenderer.svelte";
  import ProductCategory from "./components/ProductCategory.svelte";
  import CategoryRenderer from "./components/CategoryRenderer.svelte";
  import BillItem from "./components/BillItem.svelte";
  import BillRenderer from "./components/BillRenderer.svelte";

  //variables
  let currentCategoryKey = 0;
  let currentProductKey = 0;
  let billTotal = 0;

  let productLookupDoulicationFlag = -1;
  //array of all bill's details
  let billDetails = [];

  //// Bill management Routines
  const blink = () => {
    let ele = document.querySelector("#q" + productLookupDoulicationFlag);
    // alert(ele);

    let bgStyel = ele.style.backgroundColor;
    ele.style.backgroundColor = "yellow";
    setTimeout(() => {
      ele.style.backgroundColor = bgStyel;
    }, 110);
  };

  const clacTotal = () => {
    let t = 0;
    billDetails.forEach(item => {
      t += parseFloat(item.itemQuantity) * parseFloat(item.itemPrice);
    });
    return t;
  };
  const delBillItem = index => {
    if (confirm("ARE YOU SURE ??")) {
      billDetails = billDetails.filter((ele, i) => i != index);
    }
    //billDetails = billDetails;
    // productLookupDoulicationFlag = -1;
    reArrangeBillKeys();
    billTotal = clacTotal();
  };

  const reArrangeBillKeys = () => {
    billDetails.forEach((item, index) => {
      item.key = index;
    });
  };

  const updateBillValues = index => {
    let qInputs = document.querySelectorAll("#right input");
    let ele = qInputs[index];
    let value = ele.value;
    billDetails[index].itemQuantity = value;
  };
  const onBillItemUpdate = e => {
    let index = e.detail.key;
    updateBillValues(index);
    billTotal = clacTotal();
  };
  const onBillItemDelete = e => {
    let index = e.detail.key;
    delBillItem(index);
  };

  const addBillItem = (catkey, prodkey) => {
    let obj = {
      key: billDetails.length,
      catName: categories[catkey].name,
      itemImgPath: categories[catkey].products[prodkey].imgPath,
      itemName: categories[catkey].products[prodkey].name,
      itemPrice: categories[catkey].products[prodkey].price,
      itemQuantity: 1 //default value
    };
    // billDetails.push(obj);
    // billDetails = billDetails;

    //instead do list assaignment
    billDetails = [...billDetails, obj];
  };

  ///////////////////////////////////////////////////////////////////

  ////////    products and category Routines     /////////////////////

  //look up product by name in billDetails array and return
  // its index or -1
  const productLookUp = prodname => {
    let index = -1;
    for (var i = 0; i < billDetails.length; i++) {
      if (billDetails[i].itemName === prodname) {
        index = billDetails[i].key;
        break;
      }
    }
    return index;
  };

  const onCategorySelected = e => {
    currentCategoryKey = parseInt(e.detail.key);
  };

  const onProductSelected = e => {
    currentProductKey = parseInt(e.detail.key);
    // if (billDetails[currentProductKey] !== undefined)
    productLookupDoulicationFlag = productLookUp(
      categories[currentCategoryKey].products[currentProductKey].name
    );
    //alert(productLookupDoulicationFlag);
    if (productLookupDoulicationFlag == -1) {
      addBillItem(currentCategoryKey, currentProductKey);
      billTotal = clacTotal();
    } else {
      //dont add the item again instead updte its count by 1
      let qInputs = document.querySelectorAll("#right input");
      let ele = qInputs[productLookupDoulicationFlag];
      let value = parseFloat(ele.value) + 1;
      blink();
      billDetails[productLookupDoulicationFlag].itemQuantity = value;
      ele.value = value;
      billTotal = clacTotal();
    }

    //console.log(currentCategoryKey, currentProductKey, billDetails);
  };

  ////////////////////////////////////////////////////////////////////

  /////////////////////////     sample back-end data /////////////////

  let categories = [
    {
      name: "sandwitches",
      count: "2",
      products: [
        {
          name: "Burger",
          price: "100",
          desc: "",
          imgPath: "sand-burger.jpg"
        },
        {
          name: "Flafil",
          price: "80",
          desc: "",
          imgPath: "sand-flfil.jpg"
        }
      ]
    },
    {
      name: "pizza",
      count: "5",
      products: [
        {
          name: "pepperoni",
          price: "300",
          desc: "",
          imgPath: "pizza-pepperoni.jpg"
        },
        {
          name: "cheese",
          price: "300",
          desc: "",
          imgPath: "pizza-cheese.jpg"
        },
        {
          name: "chicken",
          price: "300",
          desc: "",
          imgPath: "pizza-chicken.jpg"
        },
        {
          name: "margherita",
          price: "560",
          desc: "",
          imgPath: "pizza-margherita.jpg"
        },
        {
          name: "mashroom ",
          price: "300",
          desc: "",
          imgPath: "pizza-mashroom.jpg"
        }
      ]
    },
    {
      name: "Asida",
      count: "3",
      products: [
        {
          name: "Rybe",
          price: "120",
          desc: "",
          imgPath: "asida-rybe.jpg"
        },
        {
          name: "Tagalia",
          price: "120",
          desc: "",
          imgPath: "asida-taglia.jpg"
        },
        {
          name: "Wekab",
          price: "140",
          desc: "",
          imgPath: "asida-wekab.jpg"
        }
      ]
    },
    {
      name: "Juice",
      count: "4",
      products: [
        {
          name: "Orange",
          price: "90",
          desc: "",
          imgPath: "juice-orange.jpg"
        },
        {
          name: "Mango",
          price: "90",
          desc: "",
          imgPath: "juice-mango.jpg"
        },
        {
          name: "Guava",
          price: "100",
          desc: "",
          imgPath: "juice-guava.jpg"
        },
        {
          name: "Mixed",
          price: "140",
          desc: "",
          imgPath: "juice-mixed.jpg"
        }
      ]
    }
  ];
</script>

<style>
  #content {
    width: 90%;
    height: 20%;
    /* background-color: rgb(253, 255, 130); */
    /* background-image: url(../a.JPG); */
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 12px;
    margin: 0 auto;
    padding: 10px;
  }
  #header {
    width: 100%;
    height: 80px;
    background-image: url(../images/bg.png);
    margin: 5px auto;
  }
  #products-categories,
  #products-details {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    justify-content: flex-start;
    align-content: space-between;
    width: 90%;
    height: auto;
    background-color: #fff;
    margin: 12px auto;
    padding: 4px 6px;
    border: 1px solid blue;
    border-radius: 12px;
  }
  /* #products-details {
  }
  #products-counter-details {
  } */
  #left {
    width: 65%;
    height: auto;
    float: left;
    margin: 3px;
    padding: 6px;
    background-color: rgb(255, 229, 197);
    border: 1px solid red;
    border-radius: 12px;
  }
  #right {
    background-color: rgb(247, 248, 237);
    width: 30%;
    height: auto;
    float: right;
    margin: 20px 3px;
    padding: 6px;
    border-radius: 6px;

    -webkit-box-shadow: -7px 10px 23px 0px rgba(0, 0, 0, 0.67);
    -moz-box-shadow: -7px 10px 23px 0px rgba(0, 0, 0, 0.67);
    box-shadow: -7px 10px 23px 0px rgba(0, 0, 0, 0.67);
  }
  #total {
    display: block;
    width: 50%;
    margin: 8px auto;
    padding: 5px;
    border-radius: 30px;
    text-align: center;
    background-color: rgb(251, 244, 98);
    font-size: 16px;
    color: rgb(251, 38, 38);
    font-weight: bold;
  }
</style>

<div id="content">
  <div id="header" />
  <div id="left">
    <div id="products-categories">

      <CategoryRenderer
        catList={categories}
        on:onCategorySelected={onCategorySelected} />
    </div>

    <div id="products-details">
      <ProductsRenderer
        prodList={categories[currentCategoryKey].products}
        on:onProductSelected={onProductSelected} />
    </div>
  </div>
  <div id="right">
    <div id="products-counter-details">
      <BillRenderer
        billItemsList={billDetails}
        on:BillItemUpdate={onBillItemUpdate}
        on:BillItemDelete={onBillItemDelete} />
      <span id="total">Total = {billTotal}</span>
    </div>

  </div>

</div>
